import db from '@/lib/IndexedDB'

export default {
  createDataStores(upgradeDb, resolve) {
    return Promise.allSettled([
      db.createStore('store', { keyPath: 'key' }),
      db.createStore('logs', { keyPath: 'id', autoIncrement: true }),
    ]).then(() => resolve())
  },

  install() {
    db.setName('goorder')
    db.setVersion(1)
    return db.open(upgradeDb => this.createDataStores(upgradeDb))
  },
}
